import React from "react";

export const Progress = () => {
	return (
		<>
			<div className='farmer-progress-bar'>
				<div className='progress' id='progress' />
				<div className='progress-step progress-step-active' data-title='Cart' />
				<div className='progress-step' data-title='Shipping' />
				<div className='progress-step' data-title='Payment' />
				<div className='progress-step' data-title='Review' />
			</div>
		</>
	);
};
